import React from 'react';
import { Card } from '../ui';
import './NewStoryCard.css';

/**
 * NewStoryCard component for creating a new story
 * 
 * @param {Object} props - Component props
 * @param {function} props.onClick - Click handler function
 */
const NewStoryCard = ({ onClick }) => {
  return (
    <Card 
      interactive
      className="new-story-card"
      onClick={onClick}
    >
      <div className="new-story-card__content">
        <div className="new-story-card__icon">+</div>
        <h3 className="new-story-card__title">Create New Story</h3>
      </div>
    </Card>
  );
};

export default NewStoryCard;